// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__Cp2NQ","inputWrap":"styles_inputWrap__2HJuF","input":"styles_input__1vX6u"};